import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import React from 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import DropdownSubmenu from '../dropdown/DropdownSubmenu';
import DropdownHeader from '../selects/DropdownHeader';
const MenuItem = (props) => {
    const { index, value, divider = false, disabled = false, active = false, header = false, onSelect = noop, closeMenu = noop, onMouseEnter = noop, } = props;
    if (React.isValidElement(value) && value.type === DropdownSubmenu) {
        return value;
    }
    const role = divider ? 'separator' : 'presentation';
    const classes = classNames(divider && 'divider pointer-events-none', disabled && 'disabled', active && 'active');
    const menuLink = _jsx("a", Object.assign({ role: 'menuitem' }, { children: value }));
    const handleSelectItem = (event) => {
        if (!disabled) {
            onSelect(index, event);
            if (closeMenu) {
                closeMenu();
            }
        }
    };
    const handleItemMouseEnter = (event) => {
        if (!disabled) {
            onMouseEnter(event);
        }
    };
    if (header) {
        return _jsx(DropdownHeader, { label: value, center: false });
    }
    return (_jsx("li", Object.assign({ role: role, className: classes, onClick: handleSelectItem, onMouseEnter: handleItemMouseEnter, "data-item-index": index }, { children: header ? value : menuLink })));
};
export default MenuItem;
